import { destroy, download, mutate, query, update } from "../../defaults/fetch";


export const useCreateBudget = () => {
    const createBudget = async (body) => {
        const url = `budget/create`;
        console.log(body);
        const response = await mutate(url, true, body);
        return response.message;
    }

    return createBudget;
}


export const useGetBudgets = () => {
    const getBudgets = async (year, status = 1) => {
        const url = `budget/get-all`;
        const qs = {
            page: 0,
            size: 100,
            financial_year: year,
            status: status,
            type: "REGULAR"
        }
        const { data } = await query(url, qs);
        return data;
    }
    return getBudgets;
}

export const useUploadBudgets = () => {
    const uploadBudget = async (body) => {
        const url = `budget/upload`;
        const resp = await mutate(url, true, body, {}, 'multipart/form-data', true);
        return resp;
    }
    return uploadBudget;
}


export const useUpdateBudget = () => {
    const updateBudget = async (id, body) => {
        const url = `budget/update/${id}`;

        const { message } = await update(url, body);
        return message
    }

    return updateBudget;
}


export const useDeleteBudget = () => {
    const deleteBudget = async (id) => {
        const url = `budget/delete/${id}`;
        const { message } = await destroy(url);
        return message;
    }
    return deleteBudget;
}


export const useRejectBudget = () => {
    const rejectBudget = async (id) => {
        const url = `budget/reject-budget/${id}`;
        const { data } = await update(url);
        return data;
    }
    return rejectBudget;
}

export const useSubmitForApproval = () => {
    const submitBudget = async (id) => {
        const url = `budget/submit-budget/${id}`;
        const { data } = await update(url);
        return data;
    }
    return submitBudget;
}


export const useApproveBudget = () => {
    const approveBudget = async (id) => {
        const url = `budget/approve-budget/${id}`;
        const { data } = await update(url);
        return data;
    }
    return approveBudget;
}


export const useDownloadBudgetReport = () => {
    const downloadBudgetReport = async (department = null, year, combined = false) => {
        const url = `budget/download-report`
        const resp = await download(url, `report`, 'pdf', true, {
            department,
            year: year,
            combined: combined
        })
        return resp;
    };

    return downloadBudgetReport;
}

// projection

export const useCreateProjection = () => {
    const createProjection = async (body) => {
        const url = `budget/staff-projection/create`;
        const response = await mutate(url, true, body);
        return response.message;
    }

    return createProjection;
}


export const useGetProjections = () => {
    const getProjections = async (year, status = 1) => {
        const url = `budget/get-all`;
        const qs = {
            page: 0,
            size: 100,
            financial_year: year,
            status: status,
            type: 'STAFF_PROJECTION'
        }
        const { data } = await query(url, qs);
        return data;
    }
    return getProjections;
}

export const useUploadProjections = () => {
    const uploadProjection = async (body) => {
        const url = `budget/staff-projection/upload`;
        const resp = await mutate(url, true, body, {}, 'multipart/form-data', true);
        return resp;
    }
    return uploadProjection;
}


export const useUpdateProjection = () => {
    const updateProjection = async (id, body) => {
        const url = `budget/staff-projection/update/${id}`;

        const { message } = await update(url, body);
        return message
    }

    return updateProjection;
}


export const useDeleteProjection = () => {
    const deleteProjection = async (id) => {
        const url = `budget/staff-projection/delete/${id}`;
        const { message } = await destroy(url);
        return message;
    }
    return deleteProjection;
}

export const useCreateProjectionHistory = () => {
    const createProjectionHistory = async (body) => {
        const url = `budget/staff-projection-history/add`
        const {data} = await mutate(url, true, body)
        return data
    }

    return createProjectionHistory
}


export const useUpdateProjectionHistory = () => {
    const updateProjectionHistory = async (id, body) => {
        const url = `budget/staff-projection-history/update/${id}`
        const {data} = await update(url, body)
        return data
    }

    return updateProjectionHistory
}


export const useDeleteProjectionHistory = () => {
    const deleteProjectionHistory = async (id) => {
        const url = `budget/staff-projection-history/delete/${id}`
        const {data} = await destroy(url)
        return data
    }

    return deleteProjectionHistory
}


export const useGetAllProjectionHistory = () => {
    const getAllProjectionHistory = async (id) => {
        const url = `budget/staff-projection-history/all`
        const qs = {
            projection_item: id
        }
        const {data} = await query(url, qs)
        return data
    }

    return getAllProjectionHistory
}


export const useDownloadProjectionReport = () => {
    const downloadProjectionReport = async (department = null, year) => {
        const url = `budget/staff-projection/download-report`
        const resp = await download(url, `report`, 'pdf', true, {
            department: department,
            year: year
        })
        return resp;
    };
    return downloadProjectionReport;
}


export const useDownloadYearReport = () => {
    const downloadYearReport = async (year, start, end, current) => {
        const url = `budget/download-single-year-report`
        const resp = await download(url, `report`, 'pdf', true, {
            year: year,
            start: start,
            end: end,
            current: current
        })
        return resp;
    };
    return downloadYearReport;
}
